module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Confirm action","message":"Are you sure you wish to do this: <b>{action}</b>?"},"da":{"title":"Bekræft handling","message":"Er du sikker på at du vil gennemføre denne ændring: <b>{action}</b>?"}}')
  delete Component.options._Ctor
}
